
import { defineComponent, PropType } from "vue"
import { WebinarInfo } from "@/models/WebinarInfo"

import "@/assets/infoTab.css"

export default defineComponent({
  props: {
    info: Object as PropType<WebinarInfo>
  }
})
